export { default } from "./AsyncComponent";
